export { default } from "./AsyncComponent";
